import { render, staticRenderFns } from "./StudentDetailUpdatesProcessed.vue?vue&type=template&id=ee5f9e44&scoped=true&"
import script from "./StudentDetailUpdatesProcessed.vue?vue&type=script&lang=js&"
export * from "./StudentDetailUpdatesProcessed.vue?vue&type=script&lang=js&"
import style0 from "./StudentDetailUpdatesProcessed.vue?vue&type=style&index=0&id=ee5f9e44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5f9e44",
  null
  
)

export default component.exports